// src/banner/src/Banner.tsx
import * as React from "react";

// src/banner/src/Banner.css.ts
var container = "Banner__1wgzlgz0";
var title = "Banner__1wgzlgz3";
var titleContainer = "Banner__1wgzlgz2";

// src/banner/src/Banner.tsx
function Banner({
  image,
  title: title2,
  link,
  linkTarget = "_blank",
  textColor = "#ffffff"
}) {
  const ConditionalAnchor = ({ children }) => link ? /* @__PURE__ */ React.createElement("a", { href: link, target: linkTarget, rel: "noreferrer" }, children) : /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: container,
      style: { backgroundImage: `url(${image})` }
    },
    /* @__PURE__ */ React.createElement(ConditionalAnchor, null, /* @__PURE__ */ React.createElement("div", { className: titleContainer }, title2 && /* @__PURE__ */ React.createElement("div", { className: title, style: { color: textColor } }, title2)))
  );
}
export {
  Banner as default
};
